<template>
  <div>
    <q-dialog 
      :visible="isVisible" 
      :title="title" 
      width="400px" 
      :innerScroll="false"  
      @close="onCancel"
      @cancel="onCancel"
      @confirm="confirm"
    >
      <el-form :model="formData" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="原因" prop="handleRemark">
          <el-input type="textarea" v-model="formData.handleRemark"></el-input>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
export default {
  computed: {
    title() {
      return this.auditType == 1 ? '同意': '拒绝'
    },
  },
  data() {
    return {
      isVisible: false,
      auditType: 1,
      parames: {},
      formData: {
        handleRemark: ""
      },
      
      rules: {
        handleRemark: [
          { required: true, message: '请输入原因', trigger: 'blur' },
        ]
      }
    };
  },
  methods: {
    open(type, row) {
      this.parames = row
      this.auditType = type
      this.isVisible = true
    },
    confirm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const { handleRemark } = this.formData
          const {  customerId, frozenMarginAmount,id,mchNo} = this.parames
          this.$api.dataReport.unionMchFrozenMarginAudit({
            handleRemark,
            customerId,
            frozenMarginAmount,
            id,
            mchNo,
            status: this.auditType
          }).then(res => {
            if (res.success) {
              this.$message.success("操作成功");
              this.onCancel()
              this.$emit('auditSuccess')

            }
          })
        }
      });
    },
    onCancel() {
      this.isVisible = false;
      this.formData.handleRemark = ''
    },
   
  },
};
</script>

<style lang="stylus" scoped>
</style>
